import Image from "next/image";
import { BlockProps } from "../BlocksManager/registry";

type VariantStyle = {
  card: string;
  border: string;
  icon: string;
};

const variantStyles: { [key: string]: VariantStyle } = {
  jaune: {
    card: "bg-yellow-light",
    border: "border-3 border-yellow-light hover:border-yellow",
    icon: "text-yellow",
  },
  orange: {
    card: "bg-orange-light",
    border: "border-3 border-orange-light hover:border-orange",
    icon: "text-orange",
  },
  verte: {
    card: "bg-green-light",
    border: "border-3 border-green-light hover:border-green",
    icon: "text-green",
  },
  
};

function getVariantStyle(variante?: string) {
  const key = variante?.toLowerCase?.().trim() || "jaune";
  return variantStyles[key] || variantStyles.jaune;
}



export default function PourQuiSection({ data }: BlockProps) {
  if (!data) return null;

  const items = data?.profils || data?.cibles || data?.items || [];
  const imageUrl = data?.image?.url;

  return (
    <section className="bg-white py-16 md:py-20" key={data.id}>
      <div className="container">
        <div className="grid items-start gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-16">
          {/* Colonne gauche */}
          <div>
            <h2 className="font-literata text-[38px] font-bold leading-[1.25] text-black md:text-[54px]">
              {data.titre}
            </h2>

            <div className="mt-10 flex flex-col  gap-5">
              {items.map((item: any) => {
                const style = getVariantStyle(item.variante);
                const iconUrl = item?.icon?.url;

                return (
                  <article
                    key={item.id}
                    className={`rounded-[24px]  border-2 px-6 py-5 hover:shadow-[0_18px_50px_rgba(0,0,0,0.06)] ${style.card} ${style.border}`}
                  >
                    <div className="grid grid-cols-1 items-center gap-4 md:grid-cols-[84px_1px_1fr]">
                      <div className="flex justify-center">
                        <div className="relative h-[64px] w-[64px] ">
                          {iconUrl && (
                            <Image
                              src={iconUrl}
                              alt={item?.icon?.alternativeText || item.titre}
                              fill
                              className="object-contain"
                            />
                          )}
                        </div>
                      </div>

                      <div className="hidden md:block h-full min-h-[72px] w-px bg-black" />

                      <div>
                        <h3 className="text-[26px] font-bold text-center md:text-start leading-[1.15] text-black md:text-[34px]">
                          {item.titre}
                        </h3>

                        <p className="mt-3 text-center md:text-start text-[18px] leading-[1.3] text-black/85 md:text-[24px]">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>

          {/* Colonne droite */}
          <div className="relative flex justify-center lg:justify-end">
            <div className="relative h-[420px] w-full max-w-[420px] md:h-[560px] md:max-w-[520px] lg:h-[680px] lg:max-w-[620px]">
              {imageUrl && (
                <Image
                  src={imageUrl}
                  alt={data?.image?.alternativeText || data.titre}
                  fill
                  className="object-contain object-bottom"
                  priority
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}